/**
 * A top-level grouping of the catalog: the scope an SRP or gateway page sits
 * in, and the axis SEO content (cross-links, breadcrumbs, related searches) is
 * organized by. It is not a filter of its own — it is what a search's
 * assettype, mediatype and file type add up to. See `contentTypeOf`.
 */
export enum ContentTypeEnum {
  PHOTOGRAPHY = 'photography',
  ILLUSTRATION = 'illustration',
  VECTOR = 'vector',
  FILM = 'film',
}
